export function initializeTabs(container, activeTab) {
    if (!container) {
        console.error('Container element is required for tab initialization');
        return;
    }

    const tabLinks = container.querySelectorAll('ul li a');
    const tabContents = container.querySelectorAll('[role="tabpanel"]');

    if (!tabLinks.length || !tabContents.length) {
        console.error('No tab links or content panels found');
        return;
    }

    // Add event listeners.
    tabLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            activateTab(link);
        });
        link.addEventListener('keydown', (e) => handleKeyPress(e, index));
    });

    // Activate initial tab.
    const activeTabEl = container.querySelector(`#${activeTab}`);
    if (activeTabEl) {
        activateTab(activeTabEl);
    }

    function activateTab(selectedLink) {
        // Deactivate all tabs.
        tabLinks.forEach(link => {
            link.classList.remove('active');
            link.setAttribute('aria-selected', 'false');
            link.setAttribute('tabindex', '-1');
        });
        tabContents.forEach(content => {
            content.setAttribute('hidden', '');
        });

        // Activate selected tab.
        selectedLink.classList.add('active');
        selectedLink.setAttribute('aria-selected', 'true');
        selectedLink.setAttribute('tabindex', '0');
        selectedLink.focus();

        const targetId = selectedLink.getAttribute('href').substring(1);
        const targetContent = container.querySelector(`#${targetId}`);
        if (targetContent) {
            targetContent.removeAttribute('hidden');
        }
    }

    function handleKeyPress(event, currentIndex) {
        const { key } = event;
        let targetIndex;

        switch (key) {
            case 'ArrowRight':
            case 'ArrowDown':
                event.preventDefault();
                targetIndex = (currentIndex + 1) % tabLinks.length;
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                event.preventDefault();
                targetIndex = (currentIndex - 1 + tabLinks.length) % tabLinks.length;
                break;
            case 'Home':
                event.preventDefault();
                targetIndex = 0;
                break;
            case 'End':
                event.preventDefault();
                targetIndex = tabLinks.length - 1;
                break;
            default:
                return;
        }

        activateTab(tabLinks[targetIndex]);
    }
}